import { render, staticRenderFns } from "./SegmentSrc.vue?vue&type=template&id=a2c6a65a"
import script from "./SegmentSrc.vue?vue&type=script&lang=js"
export * from "./SegmentSrc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports